import { __assign, __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { chooseWXPay } from '@/lib/script/pay';
import { isUndef } from '@/lib/utils';
var m = {
  actions: {
    /**
     * 下单报名参加赛事
     *
     * @param {} teamId
     * @param {} packageId
     * @param {} referrer 推荐人用户id
     */
    createOrder: function createOrder(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          teamId = _b.teamId,
          specialId = _b.specialId,
          packageId = _b.packageId,
          referrer = _b.referrer,
          specifications = _b.specifications,
          age = _b.age,
          gender = _b.gender,
          coin = _b.coin,
          needPay = _b.needPay,
          cityId = _b.cityId,
          specialTeamId = _b.specialTeamId,
          activitySpecialId = _b.activitySpecialId,
          _c = _b.canChangePackage,
          canChangePackage = _c === void 0 ? true : _c,
          bind_mobile = _b.bind_mobile,
          activity_special_id = _b.activity_special_id,
          optional_specifications = _b.optional_specifications,
          parent_child_avatar = _b.parent_child_avatar,
          deposit = _b.deposit,
          order_id = _b.order_id,
          orderType = _b.orderType,
          deduction_code = _b.deduction_code,
          is_other = _b.is_other;
      return __awaiter(this, void 0, void 0, function () {
        var orderId, data, orderResponse, orderRdata, payResponse, payRdata, ret;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              orderId = order_id;
              console.log('target2232313123', orderId, is_other);
              if (!isUndef(order_id)) return [3
              /*break*/
              , 2];
              data = {
                activity_special_id: activity_special_id,
                bind_mobile: bind_mobile,
                activity_id: activityId,
                team_id: teamId,
                package_id: packageId,
                referrer: referrer,
                specifications: specifications,
                optional_specifications: optional_specifications,
                age: age,
                gender: gender,
                parent_child_avatar: parent_child_avatar,
                city_id: cityId,
                special_team_id: specialTeamId,
                special_id: specialId,
                can_change_package: canChangePackage ? 1 : 0,
                deposit: deposit,
                is_other: is_other
              };

              if (deduction_code) {
                data.deduction_code = deduction_code;
              }

              if (coin > 0) {
                data.coin = coin;
              }

              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/create_order', data)];

            case 1:
              orderResponse = _d.sent();
              orderRdata = orderResponse.data;

              if (orderRdata.status !== 0) {
                return [2
                /*return*/
                , {
                  status: 'error',
                  message: orderRdata.message
                }];
              }

              orderId = orderRdata.data;
              _d.label = 2;

            case 2:
              if (!needPay) return [3
              /*break*/
              , 5];
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/pay', {
                order_id: orderId,
                type: orderType || 'order'
              })];

            case 3:
              payResponse = _d.sent();
              payRdata = payResponse.data;

              if (payRdata.status !== 0) {
                return [2
                /*return*/
                , {
                  status: 'error',
                  message: payRdata.message
                }];
              }

              if (payRdata.data.finished) {
                return [2
                /*return*/
                , {
                  status: 'success',
                  orderId: orderId
                }];
              }

              return [4
              /*yield*/
              , chooseWXPay(payRdata.data.params)];

            case 4:
              ret = _d.sent();
              return [2
              /*return*/
              , __assign(__assign({}, ret), {
                type: 'jsapi',
                orderId: orderId
              })];

            case 5:
              return [2
              /*return*/
              , {
                status: 'success',
                orderId: orderId
              }];
          }
        });
      });
    },

    /**
     * 取消订单
     */
    cancelOrder: function cancelOrder(context, _a) {
      var orderId = _a.orderId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/cancel_order', {
                params: {
                  id: orderId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 支付状态检查
     *
     * @param {} orderId 订单号
     * @param {} type  order | upgrade_order
     * @return {} rdata
     */
    payStatus: function payStatus(context, _a) {
      var orderId = _a.orderId,
          _b = _a.type,
          type = _b === void 0 ? 'order' : _b;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/pay_status', {
                params: {
                  id: orderId,
                  type: type
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    participationStatus: function participationStatus(context, _a) {
      var orderId = _a.orderId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/status', {
                params: {
                  order_id: orderId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;